export default class DtoSTEPEquipments {
    constructor(obj) {
        this.idStation = obj.idStation

        this.inputVolumeMeasurementDevice = obj.inputVolumeMeasurementDevice
        this.outputVolumeMeasurementDevice = obj.outputVolumeMeasurementDevice
        this.piezometer = obj.piezometer // Option[Long]
    }
}